import "./styles/themes/_default.scss";
import classNames from "classnames";

const SelectedStateLabel = ({ active, text }) => {
    const className = classNames("selectedStateLabel", { active: active });
    return <label className={className}>{text}</label>;
};
export default SelectedStateLabel;
